(function(holidayBundleBagTabs, $) {
  "use strict";

  var bindUIActions = function() {
    // Color Toggle Functionality
    $(".holiday-bundle-bag-looks-tabs-content-container").each(function() {
      $(this).hide();
      if ($(this).hasClass("active-color-toggle")) {
        $(this).show();
      }
    });

    $(".js-holiday-bundle-bag-swatch-container").on("click", function(e) {
      e.preventDefault();
      $(".js-holiday-bundle-bag-swatch-container").removeClass("is-active");
      var id = $(this).attr("data-holiday-swatch-id");
      $(this).addClass("is-active");

      $(".holiday-bundle-bag-looks-tabs-content-container").each(function() {
        $(this).hide();
        if ($(this).attr("id") == id) {
          $(this).show();
        }
      });
    });

    $("[data-bundle-option]").on("click", function(e) {
      // update bundle image
      e.preventDefault();
      var isLook = $(this).hasClass("is-look");
      var isColor = $(this).hasClass("is-color");

      var activeColorIndex = isColor
        ? $(this).attr("data-bundle-color")
        : $("[data-bundle-option].is-color.is-active").attr(
            "data-bundle-color"
          );

      var activeLookIndex = isLook
        ? $(this).attr("data-bundle-look")
        : $("[data-bundle-option].is-look[aria-selected='true']").attr(
            "data-bundle-look"
          );

      var $newActiveImage = $(
        `[data-bundle-image][data-bundle-color="${activeColorIndex}"][data-bundle-look="${activeLookIndex}"]`
      );

      $("[data-bundle-image]").hide();
      $newActiveImage.show();
    });

    // Looks ADA Tabs Functionality
    class LooksTabController {
      constructor(container) {
        this.container = document.querySelector(container);
        this.tablist = this.container.querySelector("[role=tablist]");
        this.tabs = this.container.querySelectorAll("[role=tab]");
        this.tabpanels = this.container.querySelectorAll("[role=tabpanel]");
        this.activeTab = this.container.querySelector(
          "[role=tab][aria-selected=true]"
        );

        this._addEventListeners();
      }

      // Private function to set event listeners
      _addEventListeners() {
        for (let tab of this.tabs) {
          tab.addEventListener("click", e => {
            e.preventDefault();
            this.setActiveTab(tab.getAttribute("aria-controls"));
          });
          tab.addEventListener("keyup", e => {
            if (e.keyCode == 13 || e.keyCode == 32) {
              // return or space
              e.preventDefault();
              this.setActiveTab(tab.getAttribute("aria-controls"));
            }
          });
        }
        this.tablist.addEventListener("keyup", e => {
          switch (e.keyCode) {
            case 35: // end key
              e.preventDefault();
              this.setActiveTab(
                this.tabs[this.tabs.length - 1].getAttribute("aria-controls")
              );
              break;
            case 36: // home key
              e.preventDefault();
              this.setActiveTab(this.tabs[0].getAttribute("aria-controls"));
              break;
            case 37: // left arrow
              e.preventDefault();
              let previous = [...this.tabs].indexOf(this.activeTab) - 1;
              previous = previous >= 0 ? previous : this.tabs.length - 1;
              this.setActiveTab(
                this.tabs[previous].getAttribute("aria-controls")
              );
              break;
            case 39: // right arrow
              e.preventDefault();
              let next = [...this.tabs].indexOf(this.activeTab) + 1;
              next = next < this.tabs.length ? next : 0;
              this.setActiveTab(this.tabs[next].getAttribute("aria-controls"));
              break;
          }
        });
      }

      // Public function to set the tab by id
      // This can be called by the developer too.
      setActiveTab(id) {
        for (let tab of this.tabs) {
          if (tab.getAttribute("aria-controls") == id) {
            tab.setAttribute("aria-selected", "true");
            tab.focus();
            this.activeTab = tab;
          } else {
            tab.setAttribute("aria-selected", "false");
          }
        }
        for (let tabpanel of this.tabpanels) {
          if (tabpanel.getAttribute("id") == id) {
            tabpanel.setAttribute("aria-expanded", "true");
            tabpanel.classList.add("is-active");
          } else {
            tabpanel.setAttribute("aria-expanded", "false");
            tabpanel.classList.remove("is-active");
          }
        }
      }
    }

    const LookstabController = new LooksTabController("#holiday-bag-looks");
  };

  holidayBundleBagTabs.init = function() {
    bindUIActions();
  };
})((window.holidayBundleBagTabs = window.holidayBundleBagTabs || {}), jQuery);
